import React, { useEffect, useMemo, useState } from 'react';
import { Sprite, Text } from '@pixi/react';
import { timeHelper } from '../../../core/helpers/timeHelper';
import { getGameImages } from '../../../core/helpers/getGameImages';

let intervalId;
function Clock() {
  const [time, setTime] = useState(timeHelper());
  const { clock } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    intervalId = setInterval(() => {
      setTime(timeHelper());
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <>
      <Sprite texture={clock} anchor={0.5} x={8} y={8} scale={0.5} />
      <Text
        text={time}
        style={{ fill: '#FFFFFF', fontSize: 12, fontWeight: 500, font: 'poppinsMedium' }}
        x={22}
      />
    </>
  );
}
export default Clock;
